import { IBlockDataModelConstructor } from '../../../interface/block/block-data-contructor.interface';
import { BaseBlockDataModel } from '../base-block-data.model';

export const authenticatedBlock = <T extends BaseBlockDataModel>(component: IBlockDataModelConstructor<T>) => {
  component.authenticatedBlock = true;
  return component;
};
